<template>
  <div id="restaurants">
    <div class="adaptive-column-content">
      <h2 v-if="!isSmartphone">Наши рестораны</h2>
      <content-loader title="Пожалуйста, подождите, мы загружаем рестораны" v-if="restaurants.length === 0" />
      <restaurant v-for="restaurant in restaurants" :restaurant="restaurant" :key="restaurant.id" v-else />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import Restaurant from '/src/components/Restaurant'
  import ContentLoader from '/src/components/ContentLoader'

  export default {
    name: 'RestaurantsPage',
    components: {
      Restaurant,
      ContentLoader
    },
    computed: {
      ...mapGetters({
        restaurants: 'content/restaurants'
      })
    },
    methods: {
      ...mapActions({
        loadRestaurants: 'content/loadRestaurants'
      })
    },
    mounted () {
      this.loadRestaurants()
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/index/Restaurants.vue